module.exports = __webpack_public_path__ + "img/1440.1f07f0e7.jpg";